<template>
  <van-uploader :max-count="1" :after-read="afterRead" v-model="bankCard"></van-uploader>
</template>

<script>
// import { Toast } from "vant";
import moment from "moment";
import getUpToken from "@/api/getUpToken";
import axios from "axios";
export default {
  props: ["label"],
  data() {
    return {
      bankCard: []
    };
  },
  methods: {
     deleter(){
      this.bankCard=[]
    },
    afterRead(file) {
      file.status = "uploading";
      file.message = "上传中...";
      return new Promise((resolve, reject) => {
        let splitArray = file.file.name.split(".");
        let current = moment()
            .format("YYYYMMDD")
            .toString(),
          prefix = moment(file.file.lastModified)
            .format("HHmmss")
            .toString(),
          suffix =
            new Date().getTime() + "." + splitArray[splitArray.length - 1],
          key = encodeURI(`${current}/${prefix}_${suffix}`);
        getUpToken({ key })
          .then(res => {
            let data = new FormData();
            data.append("token", res.data.uptoken);
            data.append("key", key);
            data.append("file", file.file);
            axios({   //上传到七牛云返回图片路径
              url: "//upload.qiniup.com",
              method: "POST",
              data: data,
              headers: {
                "Content-Type": "multipart/form-data"
              }
            })
              .then(res => {
                file.status = "done";
                file.message = "上传成功...";
                this.$emit("identityY", res.data.domain + res.data.truekey);
                this.$emit("identityZ", res.data.domain + res.data.truekey);
                this.$emit(
                  "img_bankcard_a",
                  res.data.domain + res.data.truekey
                );
                this.$emit(
                  "img_bankcard_b",
                  res.data.domain + res.data.truekey
                );
                this.$emit(
                  "img_private_idcard_a",
                  res.data.domain + res.data.truekey
                );
                this.$emit(
                  "img_private_idcard_b",
                  res.data.domain + res.data.truekey
                );
              })
              .catch(err => {
                reject(err);
                file.status = "failed";
                file.message = "上传失败";
              });
          })
          .catch(error => {
            file.status = "failed";
            file.message = "上传失败";
            reject(error);
          });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>